// extracted by mini-css-extract-plugin
export default {"attentionWrapper":"checkout-summary--attentionWrapper--7dbd35"};